// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge{
  display:flex;
  align-items:center;
  width:max-content;
  min-height:1.5rem;
  padding:1px 0.25rem;
  font-weight:700;
  white-space:nowrap;
  border-radius:1rem;
}
.badge__icon{
    display:inline-flex;
  }
.badge__text{
    font-size:0.875rem;
    line-height:1.375rem;
    margin:0 0.25rem;
  }
.badge--color-apple{
    color:#31651f;
    background-color:#e7f3e2;
  }
.badge--color-apple .badge__icon{
    color:#428629;
  }
.badge--color-apple:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-blueberry{
    color:#0b548b;
    background-color:#deeffc;
  }
.badge--color-blueberry .badge__icon{
    color:#0e70ba;
  }
.badge--color-blueberry:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-brand{
    color:#8f2522;
    background-color:#fde4e3;
  }
.badge--color-brand .badge__icon{
    color:#bf322e;
  }
.badge--color-brand:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-dark-primary{
    color:#fff;
    background-color:#206dd2;
  }
.badge--color-dark-primary .badge__icon{
    color:#fff;
  }
.badge--color-dark-primary:has(.badge__icon) .badge__text{
    color:#fff;
  }
.badge--color-error{
    color:#8b1715;
    background-color:#fdeae9;
  }
.badge--color-error .badge__icon{
    color:#c01e1c;
  }
.badge--color-error:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-grape{
    color:#552f99;
    background-color:#efe7ff;
  }
.badge--color-grape .badge__icon{
    color:#713fcc;
  }
.badge--color-grape:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-lemon{
    color:#857024;
    background-color:#fff7d7;
  }
.badge--color-lemon .badge__icon{
    color:#ad902f;
  }
.badge--color-lemon:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-light-grey{
    color:#424242;
    background-color:#f6f7f8;
  }
.badge--color-light-grey .badge__icon{
    color:#707070;
  }
.badge--color-light-grey:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-mandarin{
    color:#b65811;
    background-color:#ffede0;
  }
.badge--color-mandarin .badge__icon{
    color:#db6b16;
  }
.badge--color-mandarin:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-medium-grey{
    color:#424242;
    background-color:#e5e6e6;
  }
.badge--color-medium-grey .badge__icon{
    color:#707070;
  }
.badge--color-medium-grey:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-mint{
    color:#126250;
    background-color:#e0f2ee;
  }
.badge--color-mint .badge__icon{
    color:#18826a;
  }
.badge--color-mint:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-primary{
    color:#00429d;
    background-color:#e5f5ff;
  }
.badge--color-primary .badge__icon{
    color:#1058b8;
  }
.badge--color-primary:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-secondary{
    color:#1d6c5e;
    background-color:#e1f2f1;
  }
.badge--color-secondary .badge__icon{
    color:#1f7868;
  }
.badge--color-secondary:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--color-watermelon{
    color:#973840;
    background-color:#fee9ea;
  }
.badge--color-watermelon .badge__icon{
    color:#ca4a55;
  }
.badge--color-watermelon:has(.badge__icon) .badge__text{
    color:#424242;
  }
.badge--small{
    min-height:0.875rem;
    padding:0 0.25rem;
  }
.badge--small .badge__text{
      margin:0;
      font-size:0.675rem;
      line-height:1rem;
    }
.badge--large{
    min-height:2.5rem;
    padding:0 0.5rem;
  }
.badge--large .badge__text{
      margin:0;
      font-size:1.5rem;
      line-height:2.25rem;
    }
.badge--tile{
    min-height:2rem;
    padding:0.5rem;
  }
.badge--inline{
    background-color:inherit;
  }
.badge--inline .badge__text{
      font-weight:400;
      color:#424242;
    }
.badge--truncated-width{
    width:auto;
  }
.badge--truncated-width .badge__text{
      overflow-x:hidden;
      text-overflow:ellipsis;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
